var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropdown-link relative",
      on: {
        mouseover: function($event) {
          _vm.hover = true
        },
        mouseleave: function($event) {
          _vm.hover = false
        }
      }
    },
    [
      _c("a", { class: _vm.linkClasses, attrs: { href: _vm.href } }, [
        _vm._v(_vm._s(_vm.name)),
        _vm.hasDefaultSlot
          ? _c("span", { staticClass: "text-12 inline-block ml-8" }, [
              _vm._v("▾")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown pt-16",
          class: { active: _vm.hover && _vm.hasDefaultSlot }
        },
        [
          _c(
            "div",
            { staticClass: "dropdown-inner py-8" },
            [_vm._t("default")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }